export default __webpack_public_path__ + "static/media/nepal.9bb5b0d1.svg";